import * as React from "react";

function MmlLogo(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="171.594" height="27.038" viewBox="0 0 171.594 27.038" {...props}>
      <g id="mml-logo-250x100-01" transform="translate(-94.716 -520.384)">
        <g id="Group_11173" data-name="Group 11173" transform="translate(94.716 520.509)">
          <g id="Group_11172" data-name="Group 11172" transform="translate(0 0)">
            <path
              id="Path_43369"
              data-name="Path 43369"
              d="M346.825,548.315l-4.779,6.372H341.5l-4.674-6.393v10.67h-2.767V544.29h3.185l4.591,6.309,4.592-6.309h3.165v14.675h-2.767V548.315Z"
              transform="translate(-293.418 -540.356)"
              fill="#fff"
            />
            <path
              id="Path_43370"
              data-name="Path 43370"
              d="M446.415,568.49h2.453v10.335h-2.411l-.126-1.51a3.927,3.927,0,0,1-3.355,1.823c-3.061.021-5.325-1.865-5.325-5.492a5.033,5.033,0,0,1,5.388-5.408,3.793,3.793,0,0,1,3.292,1.678Zm-6.206,5.157a2.961,2.961,0,0,0,3.061,3.145c4.025,0,4.025-6.269,0-6.269A2.943,2.943,0,0,0,440.21,573.647Z"
              transform="translate(-379.421 -560.237)"
              fill="#fff"
            />
            <path
              id="Path_43371"
              data-name="Path 43371"
              d="M518.614,544.29v8.469l3.479-4.151h3.061v.147l-4.214,4.716,4.8,5.282v.19H522.66l-4.047-4.676v4.676h-2.558V544.29Z"
              transform="translate(-444.512 -540.356)"
              fill="#fff"
            />
            <path
              id="Path_43372"
              data-name="Path 43372"
              d="M579.942,574.264c.168,1.279,1.279,2.2,3.083,2.2a4.267,4.267,0,0,0,2.767-.965l1.634,1.615a6.349,6.349,0,0,1-4.443,1.678c-3.564,0-5.682-2.2-5.682-5.514a5.172,5.172,0,0,1,5.493-5.408c3.459,0,5.619,2.137,5.221,6.393h-8.072Zm5.619-2.117c-.168-1.342-1.216-2.012-2.683-2.012a2.783,2.783,0,0,0-2.893,2.012Z"
              transform="translate(-495.358 -559.933)"
              fill="#fff"
            />
            <path
              id="Path_43373"
              data-name="Path 43373"
              d="M832.082,544.17v12.116h7.548v2.558H829.315V544.17Z"
              transform="translate(-704.58 -540.256)"
              fill="#fff"
            />
            <path
              id="Path_43374"
              data-name="Path 43374"
              d="M908.338,568.49h2.452v10.335H908.38l-.124-1.51a3.929,3.929,0,0,1-3.356,1.823c-3.06.021-5.324-1.865-5.324-5.492a5.033,5.033,0,0,1,5.388-5.408,3.8,3.8,0,0,1,3.292,1.678Zm-6.2,5.157a2.96,2.96,0,0,0,3.06,3.145c4.025,0,4.025-6.269,0-6.269A2.943,2.943,0,0,0,902.134,573.647Z"
              transform="translate(-762.911 -560.237)"
              fill="#fff"
            />
            <path
              id="Path_43375"
              data-name="Path 43375"
              d="M979.675,544.29v5.723a4.278,4.278,0,0,1,3.4-1.657c3.018,0,5.261,1.845,5.261,5.408a5.071,5.071,0,0,1-5.325,5.408,3.76,3.76,0,0,1-3.333-1.655l-.168,1.426h-2.391V544.29Zm.167,9.475a2.968,2.968,0,1,0,5.934,0,2.851,2.851,0,0,0-2.936-3.018A2.948,2.948,0,0,0,979.842,553.765Z"
              transform="translate(-827.285 -540.356)"
              fill="#fff"
            />
            <path
              id="Path_43376"
              data-name="Path 43376"
              d="M1058.274,571.036a3.477,3.477,0,0,0-2.557-.923c-1.216,0-1.887.377-1.887,1.027,0,.67.608,1.049,1.929,1.133,1.949.126,4.424.566,4.424,3.311,0,1.824-1.488,3.4-4.445,3.4a6.048,6.048,0,0,1-4.78-1.844l1.258-1.823a5.661,5.661,0,0,0,3.564,1.445c.964.023,1.866-.481,1.866-1.237,0-.712-.587-1.006-2.056-1.09-1.949-.147-4.276-.859-4.276-3.207,0-2.39,2.473-3.228,4.36-3.228a5.55,5.55,0,0,1,4.025,1.362Z"
              transform="translate(-888.588 -560.037)"
              fill="#fff"
            />
            <g id="Group_11170" data-name="Group 11170">
              <path
                id="Path_43377"
                data-name="Path 43377"
                d="M97.719,531.776A3.73,3.73,0,0,1,98.9,534.9v3.252a5.79,5.79,0,0,0,.083,1.051,1.609,1.609,0,0,0,.23.6.915.915,0,0,0,.365.3,1.8,1.8,0,0,0,.68.122l.478.015v2.185l-.5-.014A3.864,3.864,0,0,1,97.47,541.4a4.062,4.062,0,0,1-.957-2.939v-3.441a3.038,3.038,0,0,0-.37-1.676,1.259,1.259,0,0,0-.991-.561l-.435-.043V530.82l.435-.049c.585-.063,1.361-.357,1.361-2.158v-3.494a4.113,4.113,0,0,1,.952-2.954,3.869,3.869,0,0,1,2.768-1.03l.5-.015v2.187l-.459.025a1.314,1.314,0,0,0-1.044.444,2.683,2.683,0,0,0-.332,1.57v3.384A3.585,3.585,0,0,1,97.719,531.776Z"
                transform="translate(-94.716 -521.12)"
                fill="#fff"
              />
            </g>
            <g id="Group_11171" data-name="Group 11171" transform="translate(27.629)">
              <path
                id="Path_43378"
                data-name="Path 43378"
                d="M263.442,530.815v1.918l-.434.049c-.582.063-1.358.366-1.358,2.236v3.441a4.063,4.063,0,0,1-.952,2.939,3.863,3.863,0,0,1-2.762,1.019l-.5.014v-2.186l.479-.015a1.879,1.879,0,0,0,.649-.112.841.841,0,0,0,.362-.276,1.521,1.521,0,0,0,.249-.592,5.179,5.179,0,0,0,.1-1.094V534.9a3.716,3.716,0,0,1,1.191-3.128,3.57,3.57,0,0,1-1.191-3.046v-3.384a4.322,4.322,0,0,0-.1-1.028,1.565,1.565,0,0,0-.253-.582.845.845,0,0,0-.361-.274,1.956,1.956,0,0,0-.655-.127l-.464-.025V521.12l.5.015a3.873,3.873,0,0,1,2.762,1.026,4.079,4.079,0,0,1,.952,2.958v3.494c0,1.82.771,2.1,1.348,2.158Z"
                transform="translate(-257.432 -521.12)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
        <g id="Group_11183" data-name="Group 11183" transform="translate(101.759 520.384)">
          <g id="Group_11182" data-name="Group 11182">
            <path
              id="Path_43379"
              data-name="Path 43379"
              d="M666.013,548.315l-4.78,6.372h-.545l-4.675-6.393v10.67h-2.766V544.29h3.185l4.591,6.309,4.591-6.309h3.166v14.675h-2.767V548.315Z"
              transform="translate(-565.452 -540.231)"
              fill="#fff"
            />
            <path
              id="Path_43380"
              data-name="Path 43380"
              d="M764.948,569.721l-6.309,14.653h-2.809l1.928-4.486-4.129-10.167H756.6l1.573,4.465.985,2.914,1.068-2.85,1.887-4.528Z"
              transform="translate(-648.788 -561.344)"
              fill="#fff"
            />
            <g id="Group_11175" data-name="Group 11175">
              <g id="Group_11174" data-name="Group 11174">
                <rect id="Rectangle_3680" data-name="Rectangle 3680" width="19.556" height="2.466" fill="#fff" />
              </g>
            </g>
            <g id="Group_11177" data-name="Group 11177" transform="translate(0 19.087)">
              <g id="Group_11176" data-name="Group 11176">
                <rect id="Rectangle_3681" data-name="Rectangle 3681" width="19.556" height="2.466" fill="#fff" />
              </g>
            </g>
            <g id="Group_11179" data-name="Group 11179" transform="translate(3.538 24.556)">
              <g id="Group_11178" data-name="Group 11178">
                <rect id="Rectangle_3682" data-name="Rectangle 3682" width="12.48" height="2.482" fill="#fff" />
              </g>
            </g>
            <g id="Group_11181" data-name="Group 11181" transform="translate(8.537 19.416)">
              <g id="Group_11180" data-name="Group 11180">
                <rect id="Rectangle_3683" data-name="Rectangle 3683" width="2.482" height="7.394" fill="#fff" />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_11184" data-name="Group 11184" transform="translate(105.656 530.091)">
          <path
            id="Path_43381"
            data-name="Path 43381"
            d="M161.847,578.9a1.352,1.352,0,1,1-1.352-1.352A1.352,1.352,0,0,1,161.847,578.9Z"
            transform="translate(-159.143 -577.551)"
            fill="#fff"
          />
          <path
            id="Path_43382"
            data-name="Path 43382"
            d="M188.52,578.9a1.352,1.352,0,1,1-1.351-1.352A1.352,1.352,0,0,1,188.52,578.9Z"
            transform="translate(-181.287 -577.551)"
            fill="#fff"
          />
          <path
            id="Path_43383"
            data-name="Path 43383"
            d="M215.2,578.9a1.352,1.352,0,1,1-1.353-1.352A1.352,1.352,0,0,1,215.2,578.9Z"
            transform="translate(-203.437 -577.551)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default MmlLogo;
